export class TblUsers {
  id?: number;
  userid: any;
  modified?: any;
}
